export { formatFileSize } from "./formatFileSize.js"

export function uniqueFilename(filename, existingNames) {
    if (!filename) {
        return filename
    }
    const names = new Set((existingNames ?? []).map((n) => String(n)))
    const lastDot = filename.lastIndexOf(".")
    const extension = lastDot >= 0 ? filename.slice(lastDot) : ""
    const base = lastDot >= 0 ? filename.slice(0, lastDot) : filename
    let candidate = filename
    let counter = 0
    while (names.has(candidate)) {
        counter += 1
        candidate = `${base} (${counter})${extension}`
        if (counter > 10000) {
            return null
        }
    }
    return candidate
}

export function getFilename(file) {
    return String(file?.filename ?? file?.Filename ?? "")
}

export function getFileUrl(file) {
    const url = file?.url ?? file?.URL ?? ""
    return url ? String(url) : ""
}

export function getFileSizeLabel(file) {
    return String(file?.size ?? file?.Size ?? "")
}

export function getFileTypeLabel(file) {
    const type = String(file?.type ?? file?.Type ?? "").trim()
    if (!type) {
        return ""
    }
    return type.charAt(0).toUpperCase() + type.slice(1)
}

export function viewFile(file) {
    const url = getFileUrl(file)
    if (!url) {
        return
    }
    window.open(url, "_blank")?.focus()
}

export function downloadFile(file) {
    const url = getFileUrl(file)
    const filename = getFilename(file)
    if (!url) {
        return
    }
    const a = document.createElement("a")
    a.href = url
    a.download = filename
    a.click()
}
